import { Address } from "@redotech/account-common/address";
import { DropoffSearchAddress } from "@redotech/merchant-sdk/rpc/schema/get-dropoff-locations";
import { useTranslation } from "@redotech/redo-i18n";
import { DropoffProviderType } from "@redotech/redo-return-dropoff-provider-common/dropoff-provider";
import { LocationsMapModalBody } from "@redotech/redo-web/arbiter-components/interactive-map/interactive-map";
import { memo } from "react";
import { useDropoffLocations } from "../../../hooks/use-dropoff-locations";

/**
 * Drop-off locations view rendered in place inside the create-label modal (page
 * swap, with a Back button in the footer) — mirrors the customer-portal map.
 */
export const DropoffLocationsContent = memo(function DropoffLocationsContent({
  teamId,
  provider,
  customerAddress,
  merchantAddress,
  customerCountry,
}: {
  teamId: string;
  provider: DropoffProviderType;
  customerAddress: DropoffSearchAddress;
  merchantAddress: Address;
  customerCountry?: string;
}) {
  const { t } = useTranslation();
  const query = useDropoffLocations({
    teamId,
    provider,
    customerAddress,
    merchantAddress,
    enabled: true,
  });

  return (
    <LocationsMapModalBody
      customerCountry={customerCountry}
      error={!!query.error}
      errorText={t("Error loading drop-off locations")}
      locations={query.data ?? null}
      pending={query.isPending && query.fetchStatus !== "idle"}
    />
  );
});
